import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function initTopics(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TOPICS_SCORES_FETCH,
    (organisationId, data) =>
      requestor
        .post(`${basePath}/organisation/${organisationId}/topic/scores`, data, {
          withCredentials: true,
        })
        .then(response => response.data),
  );
}
